import React from 'react';
import { motion } from 'framer-motion';
import { clsx } from 'clsx';
interface CardProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}
export function Card({
  children,
  className,
  delay = 0
}: CardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className={clsx('bg-white rounded-2xl shadow-md border border-stone-100 p-6 md:p-8', className)} data-id="element-163">
      {children}
    </motion.div>;
}